"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _grey = _interopRequireDefault(require("../tokens/color/grey"));
var _commonHelper = require("../helpers/commonHelper");
var _excluded = ["size", "isSlim", "color"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var spinnerTypes = {
  small: {
    width: 1
  },
  medium: {
    width: 1.8
  },
  large: {
    width: 2.4
  }
};
var SpinnerCircular = function SpinnerCircular(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$isSlim = _ref.isSlim,
    isSlim = _ref$isSlim === void 0 ? false : _ref$isSlim,
    color = _ref.color,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var variant = spinnerTypes[size];
  return /*#__PURE__*/_react["default"].createElement(SpinnerCircular.container, (0, _extends2["default"])({
    width: variant.width,
    color: color,
    isSlim: isSlim
  }, props));
};
SpinnerCircular.propTypes = {
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),
  isSlim: _propTypes["default"].bool,
  color: _propTypes["default"].string
};
var circularSpin = /*#__PURE__*/(0, _styledComponents.keyframes)(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var circularSpinnerBG = function circularSpinnerBG(props) {
  var color = props.color || _grey["default"].z500;
  var rgb = (0, _commonHelper.hexToRgb)(color);
  return "rgb(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ", 0.1)");
};
var borderWidth = function borderWidth(props) {
  return "".concat(props.isSlim ? 0.5 / 3 * props.width : 0.5 / 2 * props.width, "rem");
};
SpinnerCircular.container = _styledComponents["default"].div.withConfig({
  componentId: "sc-1nivt39-0"
})(["width:", "rem;height:", "rem;border-radius:50%;border:", " solid ", ";border-top:", " solid ", ";animation:", " 1s infinite linear;"], function (props) {
  return 1.4 * props.width;
}, function (props) {
  return 1.4 * props.width;
}, borderWidth, circularSpinnerBG, borderWidth, function (props) {
  return props.color;
}, circularSpin);
var _default = exports["default"] = SpinnerCircular;